import {
  EditLocationModalVM,
  OrderReviewContentVM,
} from '../../domain/entities/order-review-content/OrderReviewContentVM.type';
import { Waypoint } from '../../domain/entities/Waypoint';

export * from '../../domain/entities/order-review-content/OrderReviewContentVM.type';
export { DEFAULT_ORDER_REVIEW_CONTENT } from '../../domain/store/order-review-content/OrderReviewContentStore';

export const getEditModalByWaypoint = (
  content: OrderReviewContentVM,
  waypoint: Waypoint,
): EditLocationModalVM =>
  waypoint === 'Pickup' ? content.editPickupModal : content.editDropModal;
